export const urlGetParams = () => {
  const params = new URLSearchParams(window.location.search);
  const paramsToFilter = Array.from(params.entries()).map(([key, value]) => ({
    name: key,
    value,
  }));

  return paramsToFilter;
};

const formatUseParams = (params: URLSearchParams, paramMap: { [key: string]: any }) => {
  Object.entries(paramMap).forEach(([key, value]) => {
    const paramKey = key === 'category_ids' ? 'categories[]' : `${key}[]`;

    if (!value || !value.length) {
      params.delete(paramKey);
      return;
    }

    const existingValues = new Set(params.getAll(paramKey));

    value.forEach((val: any) => {
      const valStr = val.toString();
      if (!existingValues.has(valStr)) {
        params.append(paramKey, valStr);
      }
    });
  });
};

export const params = () => {
  return new URLSearchParams(window.location.search);
};

export const updateLocalURL = (paramMap: { [key: string]: any }) => {
  const useParams = params();
  formatUseParams(useParams, paramMap);
  window.history.pushState({}, '', `${window.location.pathname}?${useParams.toString()}`);
};
